// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const isMacOs = () => /Mac/i.test(window?.navigator?.platform);
